const conciergeMain = () => import('../views/concierge/conciergeMain')
const myCouponDTL = () => import('../views/concierge/myCouponDTL')
const giftCoupon = () => import('../views/concierge/giftCoupon')
const conciergeSendGift = () => import('../views/concierge/conciergeSendGift')

export default [

  {
    path: '/concierge/conciergeMain',
    name: '/concierge/conciergeMain',
    component: conciergeMain
  },
  {
    path: '/concierge/myCouponDTL',
    name: '/concierge/myCouponDTL',
    props: true,
    component: myCouponDTL
  },
  {
    path: '/concierge/giftCoupon/:cpNo',
    name: '/concierge/giftCoupon',
    component: giftCoupon
  },
  {
    path: '/concierge/conciergeSendGift',
    name: '/concierge/conciergeSendGift',
    component: conciergeSendGift,
    props: true
  },
]
